const actions = {
    clearRouteHistory(context) {
        context.commit("clearRouteHistory");
    },
    addRouteToHistory({ commit, state }, { route }) {
        if (state.routeHistory.length > 0
            && state.routeHistory[state.routeHistory.length - 1] == route) {
            return;
        }
        commit('addRouteToHistory', route);
    },
    goToPreviousRoute({ commit, state }, { router }) {
        if (state.routeHistory.length > 1) {
            commit('goToPreviousRoute');
            router.push(state.routeHistory[state.routeHistory.length - 1]);
        }
    },
    setLoadedEntityWithAttrs(context) {
        context.commit("setLoadedEntityWithAttrs");
    },
}

export default actions;